import { ALERT_STATUS } from '../constants/alertConstants'
import { APPOINTMENT_STATUS } from '../constants/appointmentConstants'
import { startCase } from '@dlm/common'
import { Chip } from '@enterprise-ui/canvas-ui-react'

export const getAlertStatusColor = (alertStatus) => {
  let color
  switch (alertStatus) {
    case ALERT_STATUS.AT_RISK_CRITICAL_DEPARTURE_TIME:
    case ALERT_STATUS.AT_RISK_PAST_EXPECTED_DELIVERY:
    case ALERT_STATUS.AT_RISK_PAST_EXPECTED_PICKUP:
    case ALERT_STATUS.AT_RISK_PICKUP_ARRIVAL_TIME:
      color = 'alert'
      break
    case ALERT_STATUS.AT_RISK_LATE_DEPARTURE:
    case ALERT_STATUS.EARLY_DELIVERY:
    case ALERT_STATUS.EARLY_PICKUP:
    case ALERT_STATUS.LATE_DELIVERY:
    case ALERT_STATUS.LATE_PICKUP:
      color = 'error'
      break
    default:
      color = 'default'
  }
  return color
}

export const getAppointmentStatusDisplay = (appointmentStatus) => {
  let display
  switch (appointmentStatus) {
    case APPOINTMENT_STATUS.MISSING:
      display = (
        <Chip size="dense" className="blue-chip">
          {startCase(appointmentStatus)}
        </Chip>
      )
      break
    case APPOINTMENT_STATUS.LATE:
      display = (
        <Chip size="dense" color="error">
          {startCase(appointmentStatus)}
        </Chip>
      )
      break
    case APPOINTMENT_STATUS.EARLY:
    case APPOINTMENT_STATUS.ON_TIME:
      display = (
        <Chip size="dense" color="success">
          {startCase(appointmentStatus)}
        </Chip>
      )
      break
    default:
      display = (
        <Chip size="dense" color="default">
          {startCase(appointmentStatus)}
        </Chip>
      )
  }
  return display
}
